import React from "react";
import { Plus, Star } from "lucide-react";

import Button from "../../../../components/buttons/Button";
import { EllipsisMenu } from "../../../../components/menu/ellipsis/EllipsisMenu";

import ViewContainer from "../../../../components/layout/view/ViewContainer";
import ViewHeader from "../../../../components/layout/view/ViewHeader";

import ContentPanel from "../../../../components/layout/content/ContentPanel";
import ContentItem from "../../../../components/layout/content/ContentItem";

import Heading from "../../../../components/typography/Heading";
import Text from "../../../../components/typography/Text";

import "./TalentSportsView.css";

export default function TalentSportsView({
  sports = [],
  onAdd,
  onEdit,
  onRemove,
  onPrimary,
  busy = false,
  readOnly = false,
}) {
  const sportList = Array.isArray(sports) ? sports : [];

  return (
    <ViewContainer>
      <ViewHeader
        title="Sports"
        description="My sports, positions and playing experience."
        actions={
          !readOnly && (
            <Button
              value="Add Sport"
              icon={<Plus size={16} />}
              variant="primary-outlined"
              disabled={busy}
              onClick={onAdd}
            />
          )
        }
      />

      <ContentPanel>
        {!sportList.length ? (
          <Text as="p" tone="secondary" size="sm">
            No sports added yet.
          </Text>
        ) : (
          <div className="talent-sports__list">
            {sportList.map((item) => (
              <ContentItem
                key={item.sportId}
                actions={
                  !readOnly && (
                    <EllipsisMenu
                      ariaLabel={`${item.sport} options`}
                      position="right"
                      disabled={busy}
                      options={[
                        ...(!item.isPrimary
                          ? [
                              {
                                id: "primary",
                                label: "Make Primary",
                                icon: <Star size={16} />,
                                action: () => onPrimary?.(item),
                              },
                            ]
                          : []),
                        {
                          id: "edit",
                          label: "Edit Sport",
                          action: () => onEdit?.(item),
                        },
                        {
                          id: "remove",
                          label: "Remove Sport",
                          className: "is-danger",
                          action: () => onRemove?.(item),
                        },
                      ]}
                    />
                  )
                }
              >
                <div className="talent-sports__heading">
                  <Heading as="h3" size="sm">
                    {item.sport}
                  </Heading>

                  {Boolean(item.isPrimary) && (
                    <span className="talent-sports__primary">Primary</span>
                  )}
                </div>

                {[item.role, item.mainPosition, item.otherPosition].some(
                  Boolean,
                ) && (
                  <Text as="p" tone="secondary" size="sm">
                    {[item.role, item.mainPosition, item.otherPosition]
                      .filter(Boolean)
                      .join(" · ")}
                  </Text>
                )}

                {item.availability && (
                  <Text as="p" tone="secondary" size="sm">
                    {item.availability}
                  </Text>
                )}
              </ContentItem>
            ))}
          </div>
        )}
      </ContentPanel>
    </ViewContainer>
  );
}
